import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";
import { GET_PAYMENT_ACCOUNT } from "./getPaymentAccount";

const CREATE_PAYMENT_ACCOUNT = gql(`
  mutation CREATE_PAYMENT_ACCOUNT($organizationSlug: String!) {
    paymentAccountCreate(organizationSlug: $organizationSlug) {
      ... on PaymentAccount {
        id
      }
      ... on PaymentAccountExists {
        organizationSlug
      }
    }
  }
`);

type Props = {
  organizationSlug: string;
};

export function useCreatePaymentAccount({ organizationSlug }: Props) {
  return useMutation(CREATE_PAYMENT_ACCOUNT, {
    variables: { organizationSlug },
    refetchQueries: [GET_PAYMENT_ACCOUNT]
  });
}
